import api from '@/state/services/Api'
import apiService from '@/state/services/Api'
import orderBy from 'lodash-es/orderBy'

const TOUR_SUPPORTED_FORMATS = {
  txt: 'text/plain',
  csv: 'text/csv,application/vnd.ms-excel',
  xml: 'text/xml',
}

const tours = {
  namespaced: true,
  state: {
    pk: 'uuid',
    list: {},
    selectedTour: null,
    loading: false,
    taskProgressStep: 0,
    taskInterval: null,
    taskResultDetails: [],
    supportedImportFormats: TOUR_SUPPORTED_FORMATS,
    converters: [
      '11Abtwil001',
      '11EBL001',
      '11Geuensee001',
      '11Mueswangen001',
      '11Rotkreuz001',
      '11StUrban001',
      '11Taegerig001',
      '11Wilken001',
      '11Wilken002',
      '11Zell001',
      '12Agris001',
      '12AquaGrip001',
      '12Avari001',
      '12InfoService003',
      '12InfoService004',
      '12InfoService005',
      '12MSDNAV001',
      '12Ofisa001',
      '12Ofisa002',
      '12OfisaBDi001',
      '12Proffix001',
      '12Proffix002',
      '20AbraxasFIS001',
      '20AbraxasFIS002',
      '20AbraxasVRSG001',
      '20AJL004',
      '20AxiansRuf001',
      '20Brem001',
      '20Brem002',
      '20Dialog001',
      '20Dialog002',
      '20Dialog003',
      '20Dialog004',
      '20Dialog005',
      '20DuMo001',
      '20Envos001',
      '20Europa001',
      '20GeCoti001',
      '20GeCoti002',
      '20HiSoft001',
      '20HiSoft003',
      '20HiSoft004',
      '20HzBuchsee001',
      '20Larix001',
      '20NSP003',
      '20NSP004',
      '20Ruf001',
      '20Ruf002',
      '20Ruf003',
      '20Ruf005',
      '20Ruf006',
      '20Ruf007',
      '20VRSG001',
      '20VRSG101',
      '20VRSGNSP002',
      '30Heimer001',
      '30Heimer002',
      '30HiSoft001',
      '30ISE001',
      '30ISE002',
      '30ISE004',
      '30ISE005',
      '30ISE007',
      '30Parallel001',
      '30Ruf002',
      '30RufGeSoft001',
      '30RufWWSoft001',
      '30RufWWSoft002',
      '30RufWWSoft003',
      '40SAP001',
      '50EFI001',
      'Excel',
    ],
  },
  getters: {
    pk(state) {
      return state.pk
    },
    list(state) {
      return orderBy(state.list, [tour => tour.results.name.toLowerCase()], ['asc'])
    },
    supportedImportFormats(state) {
      return state.supportedImportFormats
    },
    listConverters(state) {
      return state.converters
    },
    getSelectedTour(state) {
      return state.selectedTour
    },
  },
  mutations: {
    SET_TOURS: (state, tours) => {
      state.list = tours
    },
    SET_LOADING: (state, val) => {
      state.loading = val
    },
    SET_SELECTED_TOUR(state, payload) {
      state.selectedTour = payload
    },
  },
  actions: {
    updateSelectedTourData(context, payload) {
      context.commit('SET_SELECTED_TOUR', payload.clickedTour)
    },
    getTours() {
      return apiService.query(`tours/`).then(data => {
        return data
      })
    },
    mixTours({state}, payload){
      return apiService.patch(`tours/${payload.parent}`, {children: payload.children})
    },
    getToursCustom({state}, url) {
      return apiService.query(`${url}`).then(data => {
        return data
      })
    },
    getTour({state}, {uuid}) {
      console.log(uuid)
      return apiService.get(`tours/${uuid}`).then(data => {
        return data
      })
    },
    getToursDiscarded() {
      return apiService.query(`tours?is_discarded=true`).then(data => {
        return data
      })
    },
    getTourItems({state, commit}, tour) {
      return apiService
        .get(`tours/${tour.uuid}/items`)
        .then(data => data.results)
        .then(list => {
          return orderBy(list, [tourItem => tourItem.item_number], ['asc'])
        })
    },
    getTourItemsFull({state, commit}, tour) {
      return apiService.query(`tours/${tour.uuid}/items`).then(data => {
        return data
      })
    },

    updateTourVolume({state, commit}, {uuid, row, regId, payload}) {
      return apiService.patch(`tours/${uuid}/items/${row}/registers/${regId}`, payload).then(data => {
        return data
      })
    },

    getTablets({state, commit}) {
      return apiService.get('tablets').then(data => {
        return data
      })
    },
    discardTour({state, commit}, tour) {
      return apiService.post(`tours/${tour.uuid}/discard`).then(data => data)
    },
    assignTablet({state, commit}, {tour, payload}) {
      return apiService.post(`tours/${tour.uuid}/assignment`, payload).then(data => data)
    },
    reAssignTablet({state, commit}, {tour, payload}) {
      return apiService.put(`tours/${tour.uuid}/assignment`, payload).then(data => data)
    },
    unAssignTablet({state, commit}, tour){
 
      return apiService.delete(`tours/${tour.uuid}/assignment`).then(data => data)
    },
    restoreTour({state, commit}, tour) {
      return apiService.post(`tours/${tour.uuid}/restore`).then(data => data)
    },

    deleteTour({state, commit}, tour) {
      return apiService.delete(`tours/${tour.uuid}`).then(data => data)
    },
    importTour({state, commit}, payload) {
      return apiService.post('tours', payload).then(data => {
        return data
      })
    },
    exportTour({state, commit}, uuid) {
      const config = {responseType: 'blob'}
      return apiService.get(`tours/${uuid}/export`, config).then(data => {
        return data
      })
    },
    async simulateImportTour({state, dispatch}, {uuid, payload}) {
      const tokens = await dispatch('auth/simulateTablet', null, {root: true})
      const config = {tablet: tokens.access}
      return apiService.post(`tours/${uuid}/upload`, JSON.parse(payload), config).then(data => {
        return data
      })
    },
    readOuts({state, commit}, taskImportId) {
      return apiService
        .get('readouts/result/', {
          params: {
            task_id: taskImportId,
          },
        })
        .then(data => {
          console.log('Readouts data>>' + Object.keys(data) + '=' + Object.values(data))
          return data
        })
    },
  },
}

export default tours
